import { Text } from "@mantine/core";
import { useAppSelector } from "app/hooks";
import { selectProducts } from "features/admin/catalog/Catalog.slice";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ProductForm } from "../ProductForm";

export const EditProduct = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const product = useAppSelector(selectProducts)
    .filter((product) => product.id === id)
    .at(0);

  if (!product) {
    return <Text>{t("NOT_FOUND")}</Text>;
  }

  return <ProductForm product={product} />;
};
